import { Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatError } from '@angular/material/form-field';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CompanyService } from '../../configuration/company/company.service.service';
import { AssetGroupAttributes, CompanyAttributes, WarehouseAttributes } from '@albatrosdeveloper/ave-models-package';
import SalesOfficeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity';
import { SalesOfficeService } from '../../configuration/sales-office/sales-office.service';
import { OfficeGroupService } from '../../configuration/office-group/office-group.service';
import OfficeGroupAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/office-group/office-group.entity';
import { WarehouseService } from '../../configuration/warehouse/warehouse.service';
import { ChannelService } from '../../configuration/channel/channel.component.service';
import SalesOrganizationAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-organization/sales-organization.entity';
import DistributionChainAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/distribution-chain/distribution-chain.entity';
import ChannelAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/channel/channel.entity';
import PlantsAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/plants/plants.entity';
import { PlantsService } from '../../configuration/plant/plants.service';
import DivisionAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/division/division.entity';
import { DivisionService } from '../../configuration/division/division.service.service';
import { DistributionChainService } from '../../configuration/distribution-chain/distribution-chain.service';
import { IRequestResult } from 'app/common/interfaces';
import { AssetGroupService } from '../../asset-c/asset-group/asset-group.service';
import { getCode } from 'app/utils/method';
import VehicleTypeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/transport/vehicle-type/vehicle-type.entity';
import { VehicleTypeService } from '../../transport/type-vehicle/type-vehicle.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-configuration-filters',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    MatError,
    NgSelectModule
  ],
  templateUrl: './configuration-filters.component.html',
  styleUrl: './configuration-filters.component.scss'
})
export class ConfigurationFiltersComponent {
  getCode = getCode;
  constructor(
    private readonly companyService: CompanyService,
    private readonly salesOfficeService: SalesOfficeService,
    private readonly officeGroupService: OfficeGroupService,
    private readonly warehouseService: WarehouseService,
    private readonly channelService: ChannelService ,
    private readonly plantsService: PlantsService,
    private readonly divisionService: DivisionService,
    private readonly distributionChainService: DistributionChainService,
    private readonly assetGroupService: AssetGroupService,
    private readonly vehicleTypeService: VehicleTypeService,
    private snackBar: MatSnackBar
  ) {
  }
  @Input() form!: FormGroup;
  @Input() company: boolean = false
  @Input() companyWithMongoId: boolean = false;
  @Input() officeGroup: boolean = false;
  @Input() division: boolean = false;
  @Input() officeGroupByMongoId: boolean = false;
  @Input() salesOffice: boolean = false;
  @Input() salesOfficeWithMongoId: boolean = false;
  @Input() salesOrganizationList: SalesOrganizationAttributes[] = [];
  @Input() distributionChain: boolean=  false;
  @Input() distributionChainWithMongoId: boolean=  false;
  @Input() warehouse: boolean = false;
  @Input() warehouseWithMongoId: boolean = false;
  @Input() channelList: any[] = [];
  @Input() setCompanyOnInit: boolean = true;
  @Input() channel: boolean = false;
  @Input() plant: boolean = false;
  @Input() groupsActiveControl: boolean = false;
  @Input() vehicleType: boolean = false;

  @Input() submitted = false;

  @Input() loadData: boolean = undefined;

  @Output() selectionChangeCompany = new EventEmitter<void>();
  @Output() selectionChangeSalesGroup = new EventEmitter<void>();
  @Output() warehouseChange = new EventEmitter<any>();

  companyList: CompanyAttributes[] = [];
  salesOfficeList: SalesOfficeAttributes[] = []
  officeGroupList: OfficeGroupAttributes[] = [];
  warehouseList: WarehouseAttributes[] = [];
  plantList: PlantsAttributes[] = [];
  divisionList: DivisionAttributes[]=[];
  distributionChainList: DistributionChainAttributes[]=[];

  reasonVehicleTypeList: VehicleTypeAttributes[] = [];
  filteredReasonVehicleTypeList: VehicleTypeAttributes[] = [];

  groupList: AssetGroupAttributes[] = []

  compareById = (a: any, b: any) => a === b;

  onSelectionTerritory() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['loadData'] && changes['loadData'].currentValue === true) {
      this.loadAllData();
    }
  }

  ngOnInit() {
    if (this.loadData === undefined) {
      this.loadAllData();
    }
  }

  private loadAllData(): void {
    if(this.company || this.companyWithMongoId) this.fetchCompanies();
      if(this.officeGroup || this.officeGroupByMongoId) this.fetchOfficeGroup();
      if(this.salesOffice || this.salesOfficeWithMongoId) this.fetchAllSalesOfficeInit();
      if(this.warehouse || this.warehouseWithMongoId) this.fetchAllWarehouse();
      if(this.channel) this.fetchAllChannel();
      if(this.plant) this.fetchAllPlants();
      if(this.division) this.fetchAllDivision();
      if(this.distributionChain || this.distributionChainWithMongoId) this.fetchAllDistributionChain();
      if(this.groupsActiveControl) this.getAllGroup();
      if(this.vehicleType) this.fetchReasonVehicleTypes();
  }

  fetchReasonVehicleTypes() {
    this.vehicleTypeService.findToComboBox().subscribe({
      next: (res) => {
        this.reasonVehicleTypeList = res.data;
        this.filteredReasonVehicleTypeList = this.reasonVehicleTypeList;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener los motivos de cancelación.","Cerrar",{ duration: 3000 }
        );
      },
    });
  }

   getAllGroup(): void {
      this.assetGroupService.findToComboBox().subscribe({
        next: (res: IRequestResult<AssetGroupAttributes[]>) => {
          this.groupList = res.data;
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error fetching group',"Cerrar",{ duration: 5000});
        }
      });
    }

    //start filter
  private fetchAllDistributionChain() {
    this.distributionChainService.findToComboBox().subscribe({
      next: (res) => {
        this.distributionChainList = res.data;
      },
    });
  }

  private fetchAllWarehouse(): void {
      this.warehouseService.findToComboBox().subscribe({
        next: (res) => {
          this.warehouseList = res.data;
        },
        error: (err) => {
          this.snackBar.open(err.error.message ||"Error fetching warehouses","Cerrar",{ duration: 5000});
        },
      });
    }

  private fetchAllChannel(): void {
    this.channelService.findToComboBox().subscribe({
      next: (res) => {
        this.channelList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error fetching channels","Cerrar",{ duration: 5000});
      },
    });
  }

  private fetchCompanies(): void {
    this.companyService.findToComboBox().subscribe((res) => {
      this.companyList = res.data;

      // if (this.companyList.length === 1 && this.company && this.setCompanyOnInit) {
      //   this.form.get("companyId").setValue(this.companyList[0].id);
      // }

      // if (this.companyList.length === 1 && this.companyWithMongoId && this.setCompanyOnInit) {
      //   this.form.get("companyId").setValue(this.companyList[0]._id);
      // }
    });
  }

  private fetchOfficeGroup(): void {
    this.officeGroupService.findToComboBox().subscribe({
      next: (res) => {
        this.officeGroupList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error fetching office group","Cerrar",{ duration: 5000});
      },
    });
  }

  onCompanyChange() {
    this.selectionChangeCompany.emit();
  }

  onSalesGroupChange() {
    this.selectionChangeSalesGroup.emit();
  }

  onWarehouseSelectionChange(event: any) {
    this.warehouseChange.emit(event);
  }

  private fetchAllSalesOfficeInit(): void {
    this.salesOfficeService
      .findToComboBox(this.form.get("companyId").value)
      .subscribe({
        next: (res) => {
          this.salesOfficeList = res.data;
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error fetching sales opfice.","Cerrar",{ duration: 5000});
        },
      });
  }

  private fetchAllSalesOffice(): void {
    this.salesOfficeService
      .findToComboBoxGroup(this.form.get("salesOfficeGroupId")?.value)
      .subscribe({
        next: (res) => {
          this.salesOfficeList = res.data;
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error fetching sales office.","Cerrar",{ duration: 5000});
        },
      });
  }

  private fetchAllSalesOfficeBySalesOfficeMongoId(): void {
    this.salesOfficeService
      .findToComboBoxGroupByOneGroupId(this.form.get("salesOfficeGroupId")?.value)
      .subscribe({
        next: (res) => {
          this.salesOfficeList = res.data;
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error fetching sales office.","Cerrar",{ duration: 5000});
        },
      });
  }

  getDisplayValue(list: any[], ids: any): string {
    if (Array.isArray(ids)) {
      return list
        .filter(item => ids.includes(item._id) || ids.includes(item.id) || ids.includes(item.name) || ids.includes(item.code))
        .map(item => item.name)
        .join(', ');
    } else {
      return list.find(item => item._id === ids || item.id === ids || item.name === ids || item.code === ids)?.name ?? '';
    }
  }

  private fetchAllPlants(): void {
      this.plantsService.findToComboBox().subscribe({
        next: (res) => {
          this.plantList = res.data;
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error fetching plants","Cerrar",{ duration: 5000});
        },
      });
    }

  private fetchAllDivision(): void {
      this.divisionService.findToComboBox().subscribe({
        next: (res) => {
          this.divisionList = res.data;
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error fetching divisions.","Cerrar",{ duration: 5000});
        },
      });
    }
}
